export class BatchUtilities {
  public static getBatchPerPage<T>(arr: Array<T>, startIndex: number, numOfItems: number): Array<T> {
    if (numOfItems === 0) {
      return arr;
    } else {
      numOfItems = startIndex + numOfItems;
      return arr.slice(startIndex, numOfItems);
    }
  }

  public static getBatchesFromArray<T>(myArray: Array<T>, chunkSize: number): Array<Array<T>> {
    let index = 0;
    const arrayLength = myArray.length;
    const tempArray = [];

    for (index = 0; index < arrayLength; index += chunkSize) {
      const myChunk = myArray.slice(index, index + chunkSize);
      tempArray.push(myChunk);
    }

    return tempArray;
  }

  public static randomDelay(max: number): number {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0] % max;
  }
}
